import axios from 'axios';

export const createAccessKey = async (eventName: string) => {
    const response = await axios.post('/api/event/accessKey/create', { eventName });
    return response.data;
}

export const fetchLiveEvents = async () => {
    const { data: response } = await axios.get('/api/stats/live');
    if (!response.success) {
        throw new Error("Error in fetching live stats")
    }
    return response.data;
}

export const fetchAllEvents = async () => {
    const { data: response } = await axios.get('/api/stats/all');
    if (!response.success) {
        throw new Error("Error in fetching all stats")
    }
    return response.data;
}